import theme from './theme';
import {modularScale as calculateByModularScale} from 'polished';
import {css} from '@emotion/react';
import RoundAppButton from "../components/round-app-button";
import React from "react";
import {globalHistory} from "@reach/router";

export function localizedAsset(lang, de, en) {
    return lang === "de" ? de : en;
}

export function createPaging(targetName, prevTitle, nextTitle, currentPage, totalPages) {
    const previousPage = currentPage - 1;
    const nextPage = currentPage + 1;
    let result = [];

    if (previousPage >= 0) {
        let linkTarget = '/' + targetName + '/';
        if (previousPage > 0) {
            linkTarget += previousPage + '/';
        }

        result.push(<RoundAppButton title={prevTitle} linkTarget={linkTarget} big={true}/>);
    }

    if (nextPage < totalPages) {
        let linkTarget = '/' + targetName + '/' + nextPage + '/'

        if (result.length === 1) {
            result.push(<span>&nbsp;&nbsp;</span>);
        }

        result.push(<RoundAppButton title={nextTitle} linkTarget={linkTarget} big={true}/>);
    }

    return result;
}

/*
 * Module scale helper.
 * All font size values are not provided by its absolute px value but calculated from the base font size by
 * using a factor.
 */
export function modularScale(steps) {
    return calculateByModularScale(steps, '1rem', theme.typography.fontSizeScale);
}

export const checkmarkList = css`

    ul {
        position: relative;
        padding-left: 0px;
        display: block;
        font-weight: ${theme.typography.heading.pageHeadingFontWeight};
    }

    li::before {
        position: absolute;
        left: 0px;
        content: "✓";
        color: #000000;
        display: list-item;
        align-items: center;
        justify-content: center;
    }

    li {
        position: relative;
        list-style: none;
        padding-left: 30px;
        padding-bottom: 15px;
    }
`;

export const centeredContentNoPadding = css`
    box-sizing: border-box;
    max-width: ${theme.dimensions.maxCenteredContentWidth};
    min-width: 280px;
    position: relative;
    margin: 0 auto;
    padding-left: 0;
    padding-right: 0;

    @media (min-width: ${theme.breakpoints.tablet}px) {
        padding-left: 0;
        padding-right: 0;
    }
`;

export const centeredContent = css`
    box-sizing: border-box;
    max-width: ${theme.dimensions.maxCenteredContentWidth};
    min-width: 280px;
    position: relative;
    margin: 0 auto;
    padding-left: ${theme.dimensions.contentPadding};
    padding-right: ${theme.dimensions.contentPadding};

    @media (min-width: ${theme.breakpoints.tablet}px) {
        padding-left: ${theme.dimensions.contentPaddingBig};
        padding-right: ${theme.dimensions.contentPaddingBig};
    }
`;

export const formButton = css`
    height: 50px;
    color: ${theme.colors.white};
    background-color: ${theme.colors.button};
    border: 0 none;
    border-radius: 25px;
    padding-left: 30px;
    padding-right: 30px;
    cursor: pointer;
    text-transform: uppercase;
    font-weight: 600;
`;

export const formInput = css`
    height: 50px;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
`;